import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

interface ConsumerInfo {
  salesOrder: string
  salesOrderId?: string
  customerPo?: string
  invoiceWeights?: string
  consumer?: any
  name?: any
}

interface OutboundTicketState {
  outboundTicketId: string
  consumerInfo: ConsumerInfo
  submittedFromDispatchBlade: boolean
}

const initialState: OutboundTicketState = {
  outboundTicketId: '',
  consumerInfo: {
    salesOrder: '',
    salesOrderId: '',
    customerPo: '',
    invoiceWeights: '',
    consumer: {},
  },
  submittedFromDispatchBlade: false,
}

export const outboundTicketSlice = createSlice({
  name: 'outboundTicket',
  initialState,
  reducers: {
    setConsumerInfo: (state, action: PayloadAction<ConsumerInfo>) => {
      state.consumerInfo = action.payload
    },
    clearConsumerInformation: state => {
      state.consumerInfo = initialState.consumerInfo
    },
    setOutboundTicketId: (state, action: PayloadAction<string>) => {
      state.outboundTicketId = action.payload
    },
    clearOutboundTicketId: state => {
      state.outboundTicketId = initialState.outboundTicketId
    },
    setSubmittedFromDispatchBlade: (state, action) => {
      state.submittedFromDispatchBlade = action.payload
    },
    clearSubmittedFromDispatchBlade: state => {
      state.submittedFromDispatchBlade = initialState.submittedFromDispatchBlade
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.consumerInfo = initialState.consumerInfo
        state.outboundTicketId = initialState.outboundTicketId
        state.submittedFromDispatchBlade = initialState.submittedFromDispatchBlade
      }
    })
  },
})

export const {
  setConsumerInfo,
  clearConsumerInformation,
  setOutboundTicketId,
  clearOutboundTicketId,
  setSubmittedFromDispatchBlade,
  clearSubmittedFromDispatchBlade,
} = outboundTicketSlice.actions

export default outboundTicketSlice.reducer
